import { Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';
import AccessSubsidizedNSH from './AccessSubsidizedNSH';
import PercentByQualityRating from './PercentByQualityRating';
import PercentBySettingType from './PercentBySettingType';
import ErrorBoundary from '../ErrorBoundary';

function Q3Row2() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <SubquestionBox color={lightColor}>
      <Grid
        spacing={2}
        container
        direction="row"
        justify="center"
        alignItems="center"
      >

        <Grid item xs={12}>
          <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
            Access to NSH child care
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
          >
            <Grid item xs={10} sm={6}>
              <MessageBox>
                <ErrorBoundary>
                  <AccessSubsidizedNSH />
                </ErrorBoundary>
              </MessageBox>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} align="center">
          <ErrorBoundary>
            <PercentBySettingType height={245} />
          </ErrorBoundary>
        </Grid>
        <Grid item xs={12} sm={6} align="center">
          <ErrorBoundary>
            <PercentByQualityRating height={245} />
          </ErrorBoundary>
        </Grid>

      </Grid>
    </SubquestionBox>
  );
}

export default Q3Row2;
